import type { Palette } from "@designboticteam/core";
import type { ZoneStyleDefinition, ZoneType } from "./types";

type ZoneStyleByType = Record<ZoneType, ZoneStyleDefinition>;

const createZoneStyleByType = (palette: Palette): ZoneStyleByType => ({
	CheckZone: {
		label: "Check zone",
		color: palette.main.secondary,
		vertexHandleHighlightColor: palette.tones.secondary[40],
		highlightedEdgeColor: palette.tones.secondary[40],
		selectedEdgeColor: palette.tones.secondary[30],
		offsetY: 0.0001,
	},
	BuildingZone: {
		label: "Building zone",
		color: palette.main.tertiary,
		vertexHandleHighlightColor: palette.tones.tertiary[40],
		highlightedEdgeColor: palette.tones.tertiary[40],
		selectedEdgeColor: palette.tones.tertiary[30],
		offsetY: 0.0002,
	},
	ExcludedZone: {
		label: "Excluded zone",
		color: palette.main.error,
		vertexHandleHighlightColor: palette.tones.error[40],
		highlightedEdgeColor: palette.tones.error[40],
		selectedEdgeColor: palette.tones.error[30],
		offsetY: 0.0003,
	},
});

export { createZoneStyleByType, type ZoneStyleByType };
